<template>
  <v-container fluid class="container--style">
    <div>
      <v-snackbar class="new-alert" v-model="alert" :timeout="timeout" :color="alertType" top="top">
        {{this.alertMessage}}
        <v-icon color="white" flat @click="alert = false">close</v-icon>
      </v-snackbar>
    </div>
    <v-layout>
      <v-flex md12 lg12 xs12 sm12 xl12>
        <h2>Estado de aprobación</h2>
        <v-card class="comentario" dark>
          <v-card-title class="color">
            <v-layout>
              <v-chip>
                <v-avatar>
                  <v-icon dark>account_circle</v-icon>
                </v-avatar>Observacion DCA
              </v-chip>
            </v-layout>
            <!-- <v-layout justify-end>
              <span>{{date}}</span>
            </v-layout> -->
          </v-card-title>
          <v-layout align-center>
            <v-flex md12 lg12 xs12 sm12 xl12>
              <v-layout>
                <v-card-text class="fontSize" v-if="estado">Estado: Información aprobada por DCA</v-card-text>
              </v-layout>
              <v-layout>
                <v-card-text
                  class="fontSize"
                  v-if="!estado"
                >Estado: La información aún no ha sido aprobada por DCA</v-card-text>
              </v-layout>
              <v-layout>
                <v-card-text class="fontSize">Observación: {{obsEtapa}}</v-card-text>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>

        <v-card v-if="nEtapa==6" class="comentario" dark>
          <v-card-title class="color">
            <v-layout>
              <v-chip>
                <v-avatar>
                  <v-icon dark>account_circle</v-icon>
                </v-avatar>Observacion Prorrector: Plan de mejoramiento
              </v-chip>
            </v-layout>
            <!-- <v-layout justify-end>
              <span>{{etapa.fechaEtapa7}}</span>
            </v-layout> -->
          </v-card-title>
          <v-layout align-center>
            <v-flex md12 lg12 xs12 sm12 xl12>
              <v-layout>
                <v-card-text
                  class="fontSize"
                  v-if="etapa.etapa7Dca"
                >Estado: Plan de mejoramiento aprobado por Prorrector</v-card-text>
              </v-layout>
              <v-layout>
                <v-card-text
                  class="fontSize"
                  v-if="!etapa.etapa7Dca"
                >Estado: Plan de mejoramiento aún no ha sido aprobado por Prorrector</v-card-text>
              </v-layout>
              <v-layout>
                <v-card-text class="fontSize">Observación: {{etapa.comentarioEtapa7}}</v-card-text>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card> 

        <v-card v-if="nEtapa==6" class="comentario" dark>
          <v-card-title class="color">
            <v-layout>
              <v-chip>
                <v-avatar>
                  <v-icon dark>account_circle</v-icon>
                </v-avatar>Observacion Prorrector: Proceso de autoevaluación
              </v-chip>
            </v-layout>
            <!-- <v-layout justify-end>
              <span>{{etapa.fechaEtapa6Gral}}</span>
            </v-layout> -->
          </v-card-title>
          <v-layout align-center>
            <v-flex md12 lg12 xs12 sm12 xl12>
              <v-layout>
                <v-card-text
                  class="fontSize"
                  v-if="estadoPro"
                >Estado: Información aprobada por el Prorrector</v-card-text>
              </v-layout>
              <v-layout>
                <v-card-text
                  class="fontSize"
                  v-if="!estadoPro"
                >Estado: La información aún no ha sido aprobada por el Prorrector</v-card-text>
              </v-layout>
              <v-layout>
                <v-card-text class="fontSize">Observación: {{obsEtapaPro}}</v-card-text>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>


<script>
export default {
  data() {
    return {
      date:"",
      nEtapa: "",
      estadoVipo: "",
      obsEtapaVipo: "",
      estadoPro: "",
      obsEtapaPro: "",
      estado: "",
      etapa: "",
      obsEtapa: "",
      alertType: "",
      alertMessage: "",
      alert: false,
      timeout: 4000,
      auth: {
        headers: { Authorization: "" + this.$session.get("jwt") }
      }
    };
  },

  watch: {
    // cuando 'question' cambie, se ejecutará esta función
    "$route.fullPath": function() {
      //console.log("whatcher a detectado un cambio en user");
      this.verificaPath();
    }
  },

  created() {
    this.verificaPath();
  },

  methods: {
    verificaPath() {
      if (this.$route.fullPath == "/documentos/estadoE1") {
        this.nEtapa = 1;
      }
      if (this.$route.fullPath == "/documentosFinales/estadoE7") {
        this.nEtapa = 7;
      }
      if (this.$route.fullPath == "/documentos45/estadoE4") {
        this.nEtapa = 5;
      }
      /* if (
        this.$route.fullPath == "/documentosEtapa5/estadoE5" ||
        this.$route.fullPath == "/documentosEtapa5/estadoE5"
      ) {
        this.nEtapa = 5;
      } */
      if (this.$route.fullPath == "/documentosActa/estadoActa") {
        this.nEtapa = 6;
      }
      this.getEtapa();
    },
    getEtapa() {
      axios
        .get(
          process.env.ROOT_API +
            "/etapa/etapaUsuario?idPostgrado=" +
            this.$session.getAll().ccData.id,
          this.auth
        )
        .then(response => {
          //console.log("ESTADO");
          //console.log(this.nEtapa);
          //console.log(response.data);
          //console.log(response.data["comentarioEtapa" + this.nEtapa]);
          this.obsEtapa = response.data["comentarioEtapa" + this.nEtapa];
          this.etapa = response.data;
          this.estado = this.etapa["etapa" + this.nEtapa + "Dca"];
          this.date = this.etapa["fechaEtapa" + this.nEtapa];

          this.obsEtapaVipo =
            response.data["comentarioEtapa" + this.nEtapa + "Gral"];
          this.estadoVipo = this.etapa["etapa" + this.nEtapa + "Otro"];

          this.obsEtapaPro =
            response.data["comentarioEtapa" + this.nEtapa + "Gral"];
          this.estadoPro = this.etapa["etapa" + this.nEtapa + "Otro"];
          //console.log(this.obsEtapa);
        })
        .catch(error => {
          console.error(error);
          this.showAlert("error", error.response.data);
        });
    },

    showAlert(type, message) {
      this.alertType = type;
      this.alertMessage = message;
      this.alert = true;
    }
  }
};
</script>

<style scoped>
.new-alert {
  width: auto;
  margin-top: 5px;
  margin-left: auto;
  margin-right: auto;
}

.v-card {
  padding-right: 0% !important;
  padding-left: 0% !important;
  padding-top: 0% !important;
}

.v-card__title.color {
  background: #eb7704;
  font-size: 14px;
  padding: 5px;
}

.v-card__text {
  background-color: #4376a2;
  padding: 1%;
  text-align: justify;
}
.comentario {
  margin-left: 5%;
  margin-right: 5%;
  margin-top: 2%;
  margin-bottom: 2%;
}

.container--style {
  padding: 0 !important;
  width: 100% !important;
  height: 100% !important;
}

.fontSize {
  font-size: 20px !important;
}

.carousel {
  height: 650px !important;
  width: 650px !important;
  margin: 1% auto 1% auto !important;
}

.v-list-new {
  height: 100% !important;
}

.v-btn__content {
  font-size: 10px !important;
}

.theme--light.v-btn {
  color: white;
}

.v-btn {
  font-size: 10px;
  border-radius: 50px;
}

.image {
  cursor: pointer;
}

.color{
  background-color: #1c345d !important;
} 
</style>




// WEBPACK FOOTER //
// src/components/dca/documentosPost/Comentario.vue